import Icon from '@passkeys/ui/icon';
import Text from '@passkeys/ui/text';

import useNavigate from '@/ui/hooks/use-navigate';
import usePendingCount from './use-pending-count.js';

function HistoryButton() {
  const navigate = useNavigate();

  const count = usePendingCount();
  const showCount = count > 0;

  const handleClick = () => {
    navigate('/my-passkey/history');
  };

  return (
    <button
      className="relative inline-flex items-center justify-center text-black transition-opacity hover:opacity-50 theme-dark:text-neutral-200"
      onClick={handleClick}
      type="button"
      data-testid="history-button"
    >
      {showCount && (
        <div className="absolute left-[3px] top-[6px] flex h-[19px] w-[19px] items-center justify-center">
          <Text size={12} className="text-white">
            {count < 10 ? count : '9+'}
          </Text>
        </div>
      )}
      <Icon
        name={showCount ? 'circle-arc-right' : 'clock-arc-right'}
        size={32}
      />
    </button>
  );
}

export default HistoryButton;
